<template>
    <div class="header-wrapper" :class="{ 'header-selected': isSelected }" @click="handleClick">
        <div>{{ title }}</div>
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: "EditableListHeader",
    props: {
        title: String,
        isSelected: Boolean
    },
    methods: {
        handleClick() {
            this.$emit("headerClick");
        }
    }
};
</script>

<style lang="less" scoped>
.header-wrapper {
    display: flex;
    font-size: 14px;
    padding: 10px 8px 10px 16px;
    justify-content: space-between;
    flex-shrink: 0;
    align-items: center;
    cursor: pointer;

    &:hover {
        background: rgba(217, 235, 246, 0.7);
        color: #2ec2ff;

        .small-label {
            color: #2ec2ff;
        }
    }
}
.header-selected {
    color: #2ec2ff;
    background: rgba(217, 235, 246, 1);
}
</style>
